module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('a', {
    staticStyle: {
      "color": "#000000",
      "cursor": "pointer",
      "margin-top": "-0.4em",
      "padding-top": "0px",
      "float": "right"
    },
    on: {
      "click": function($event) {
        _vm.dropMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fas fa-ellipsis-v",
    staticStyle: {
      "font-size": "1.48em",
      "color": "#5703a5"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "menu-nav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.dropMenu()
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('h3', {
    staticStyle: {
      "clear": "both",
      "margin-top": "-2em",
      "margin-left": "0.71em",
      "font": "1.5em agency-fb",
      "font-weight": "200"
    }
  }, [_vm._v("XXXX")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both",
      "margin": "1em",
      "display": "none"
    }
  }), _vm._v(" "), (_vm.loggedIn) ? _c('p', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user.user_name))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "m-nav",
    staticStyle: {
      "margin-left": "0.71em"
    }
  }, [_c('ul', [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/cart"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-cart"
  }), _vm._v("Shopping Cart")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/wishlist"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v("Wishlist")])]), _vm._v(" "), _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/account"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v("My Account")])])])]), _vm._v(" "), _c('div', {
    staticClass: "m-navg",
    staticStyle: {
      "margin-left": "0.71em"
    }
  }, [_c('hr'), _vm._v(" "), _c('ul', [_c('li', {}, [_c('a', {
    attrs: {
      "href": "/agentservices"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v("MultiShop Agent")])])])]), _vm._v(" "), _c('hr', {
    staticStyle: {
      "border-top": "#f9f9fb solid",
      "margin": "1em",
      "margin-top": "0.3em",
      "margin-right": "1.73em"
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('ul', {
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('b', [_vm._v(_vm._s(_vm.user.user_name))])])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/account"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-user"
  }), _vm._v(" Account")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/timeline"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-shopping-bag"
  }), _vm._v(" Market")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "/orders"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-book"
  }), _vm._v(" Orders")])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/wishlist"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-heart"
  }), _vm._v(" Wishlist")])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/buypoint"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-users"
  }), _vm._v(" Shop Together")])]) : _vm._e(), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" Logout")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Login")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "/register"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Register")])]) : _vm._e()]), _vm._v(" "), _c('div', [_c('div', {
    staticClass: "col-xs-12 row-01"
  }, [_c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/orders"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_vm._m(1), _vm._v(" "), _c('p', [_vm._v("Recent Orders")])])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6)])]), _vm._v(" "), _c('hr'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('div', {
    staticClass: "bottomnav m-nav"
  }, [_c('div', [_c('ul', {
    staticStyle: {
      "margin": "0",
      "padding": "0px"
    }
  }, [_c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/notifications"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-bell"
  }), (_vm.notifications_alert > 0) ? _c('sup', {
    staticClass: "notify-alert"
  }, [_vm._v(_vm._s(_vm.notifications_alert))]) : _vm._e(), _c('span', [_vm._v("Notifications & Messages")])])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-off"
  }), _vm._v(" Logout")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/login"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Login")])]) : _vm._e(), _vm._v(" "), (!_vm.loggedIn) ? _c('li', {
    staticStyle: {
      "display": "inline-block"
    }
  }, [_c('a', {
    attrs: {
      "href": "/register"
    },
    on: {
      "click": function($event) {
        _vm.hideMenu()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-power-on"
  }), _vm._v(" Register")])]) : _vm._e()])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "0 1em"
    }
  }, [_c('p', {
    staticStyle: {
      "margin-left": "45vw",
      "padding-right": "1em",
      "margin-top": "-0.5em",
      "font-size": "13px"
    }
  }, [_c('a', [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" Search For _____________ ")])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "clear": "both"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('i', {
    staticClass: "fa fa-shopping-basket"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-list"
  })]), _vm._v(" "), _c('p', [_vm._v("My Lists")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-credit-card",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm._v(" "), _c('p', [_vm._v("Make Payment")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-shopping-bag"
  })]), _vm._v(" "), _c('p', [_vm._v("Add Shop")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-cubes"
  })]), _vm._v(" "), _c('p', [_vm._v("Manage Shop")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-6 node01"
  }, [_c('div', {
    staticClass: "box01"
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-upload"
  })]), _vm._v(" "), _c('p', [_vm._v("Upload Product")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "1.71em"
    }
  }, [_c('p', [_vm._v("Search For"), _c('br'), _vm._v("\r\n            _________________Men Wears")]), _vm._v(" "), _c('p', [_vm._v("Select Type (if sub)"), _c('br'), _vm._v("\r\n            _________________Trousers")]), _vm._v(" "), _c('p', [_vm._v("Pick Size(if sizes) or Color (if colors) + all_option"), _c('br'), _vm._v("\r\n            _________________Trousers")]), _vm._v(" "), _c('button', {
    staticClass: "btn sp-button-sm btn-sm"
  }, [_vm._v("Go >> ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3943e9ee"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/templates/account-menu.vue
// module id = 529
// module chunks = 0